import React, { Component, useEffect, useRef, useState } from "react";
import InventoryDetails from "../components/InventoryDetails";
import Table from "../ui/Table";
import Space from "../ui/Space";
import InventoryHistory from "../components/InventoryHistory";
//import { search } from "../temp";
import InventoryTitleLinkList from "../components/InventoryTitleLinkList";
import InventoryList from "../components/InventoryList";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import Nav from "../ui/Nav";
import { createModal } from "../hooks/createModal";
import InventorySearch from "../popups/InventorySearch";
import { useGlobals } from "../hooks/Globals";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { ROUTES } from "../utils/Routes";
import InventoryIndex from "../popups/InventoryIndex";
import InventoryMessage from "../popups/InventoryMessage";
import dayjs from "dayjs";
import { diffObjs, istl, kbdEvent } from "../utils/Utils";
import { createScreen } from "../hooks/createScreen";
import AuthorPickerScreen from "../screens/AuthorPickerScreen";
import InventoryAdjust from "../popups/InventoryAdjust";
import InventoryPubstock from "../components/InventoryPubstock";
import Confirm from "../popups/Confirm";
import Divider from "../ui/Divider";
import TextButton from "../ui/TextButton";
import { stock_structure } from "../data_structures/Stock";
import InventoryExtra from "../popups/InventoryExtra";
import SupplierDetails from "../components/SupplierDetails";
import SuppliersList from "../components/SuppliersList";


export default function SuppliersController(props) {

    const { controller = "", signal = {}, setController = () => { }, is_modal = false, search = "" } = props;
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState({});

    const [filters, setFilters] = useState({ sort: "name", limit: 45 });


    const suppliers_nav = [
        { key: KBD.ESCAPE, action: () => { (is_modal) ? props.callback(false) : setController("home") } },
        { key: KBD.ENTER, action: () => { (is_modal) ? props.callback(selected) : console.log(selected) } },
        { text: "Cpy" },
        { text: "Del" },
        { text: "Edt" },
        { text: "@Edt" },
        { text: "Ind" },
        { text: "Label" },
        { text: "Msg" },
        { text: "New" },
        { text: "Prt" },
        { text: "Srch" },
        { text: "View" },
        { text: "Web" },
        { text: "Xtra" },
    ]


    useEffect(() => {
        const cleanup = listen(controller, ROUTES.SUPPLIERS.SUPPLIERS, suppliers_nav);
        return cleanup;
    }, [suppliers_nav, selected])

    useEffect(() => { window.bm_state.value = ROUTES.SUPPLIERS.SUPPLIERS }, []);



    return (
        <div className="controller">
            <div style={{ height: "calc(100vh - 140px)", minHeight: "511px", gap: "15px" }}>
                <SupplierDetails controller={controller} selected={selected} />
                <div className="shim" />
                <Space grow size={15} style={{ "alignItems": "flex-start", "padding": "0px 0px", "padding": "0px 15px" }}>


                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 600 }}>
                        <SuppliersList

                            controller={controller}
                            search={search}
                            // filterLocal={filterLocal}
                            signal={signal}
                            // in_stock={in_stock}
                            // isTitleLink={isTitleLink}
                            // view={state.view}
                            // align={align}
                            // setAlign={setAlign}
                            selected={selected}
                            setSelected={setSelected}
                            loading={loading}
                            setLoading={setLoading}
                            data={data}
                            setData={setData}
                            filters={filters}
                            setFilters={setFilters}
                            route={ROUTES.SUPPLIERS.SUPPLIERS}
                        />
                    </div>

                   
                </Space>

            </div>


            <div className="shim" />
            <Divider />
            <div style={{ 'height': "30px" }}>
                <Space style={{ "padding": "0px 15px" }}>
                    <Nav nav={suppliers_nav} />
                </Space>
            </div>
        </div>

    )




}